import { isNull, isObject, isUndefined } from '@4players/odin-common';
import { marker as _ } from '@vandres/ngx-translate-extract-marker';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateParser,
} from '@ngx-translate/core';

export class CustomTranslateParser extends TranslateParser {
  interpolate(expr: string | Function, params?: any): string {
    let result: string;

    if (typeof expr === 'string') {
      result = this.interpolateString(expr, params);
    } else if (typeof expr === 'function') {
      result = this.interpolateFunction(expr, params);
    } else {
      result = expr as string;
    }

    return result;
  }

  getValue(target: any, key: string): any {
    const keys = key.split('.');
    key = '';

    do {
      key += keys.shift();
      if (
        !isUndefined(target) &&
        !isNull(target) &&
        !isUndefined(target[key]) &&
        !isNull(target[key]) &&
        (isObject(target[key]) || !keys.length)
      ) {
        target = target[key];
        key = '';
      } else if (!keys.length) {
        target = undefined;
      } else {
        key += '.';
      }
    } while (keys.length);

    return target;
  }

  private interpolateFunction(fn: Function, params?: any): string {
    return fn(params);
  }

  private interpolateString(expr: string, params?: any): string {
    if (!params) {
      return expr;
    }

    return expr.replace(/\[\s?([^{}\s]*)\s?\]/g, (substring: string, b: string) => {
      const r = this.getValue(params, b);
      return isUndefined(r) ? substring : r;
    });
  }
}

export class CustomMissingTranslationHandler extends MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): any {
    let text = params.key;
    if (params.interpolateParams) {
      for (const [key, value] of Object.entries(params.interpolateParams)) {
        text = text.replace(`[${key}]`, value);
      }
    }
    return text;
  }
}

// mark gateway region names for translation
_('Europe');
_('US Central');
_('US East');
_('US West');
_('South America');
_('Asia North East');
_('Oceania');
